import React, { useState } from "react";
import ModalV2 from "../modalV2";
import { Copy, Loader2, X } from "lucide-react";
import useCopyToClipboard from "../../../hooks/CopyHook";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  selectChatId,
  selectSharedToken,
  setSharedToken,
} from "../../../states/slices/globalReducer";
import { MdUpdate } from "react-icons/md";
import { RegenerateShareToken } from "../../../services/others/service";
import toast from "react-hot-toast";
function ShareModal({
  open,
  close,
  share_id,
  handleUpdateshareToken,
  loading,
}: {
  open: boolean;
  close: () => void;
  share_id: string | null;
  loading: boolean;
  handleUpdateshareToken: () => void;
}) {
  const [isCopied, copyToClipboard] = useCopyToClipboard();
  const dispatch = useAppDispatch();
  const sharedToken = useAppSelector(selectSharedToken);

  return (
    <ModalV2
      isOpen={open}
      isClose={close}
      maxWidth="w-[500px]"
      edges="rounded-2xl"
    >
      <div className="bg-gray-900 p-6 text-white rounded-2xl">
        {/* Header */}
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-medium">Public link created</h2>
          <button
            onClick={close}
            className="p-1 rounded-full hover:bg-gray-700"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Description */}
        <p className="mt-2 text-sm text-gray-300">
          A public link to your chat has been created. Manage your previous
          chats at any time via
          <a href="#" className="text-blue-400 underline">
            {" "}
            History
          </a>
          .
        </p>

        {/* Link Input & Copy Button */}
        <div className="flex items-center space-x-2 mt-4">
          <input
            type="text"
            value={`https://judexai-judge.vercel.app/chat/share/${share_id}`}
            readOnly
            className="w-full p-2 rounded-lg bg-gray-800 text-gray-300"
          />
          {share_id === sharedToken ? (
            <button
              onClick={handleUpdateshareToken}
              className="p-2 rounded-lg bg-gray-700 hover:bg-gray-600"
            >
              {loading ? (
                <Loader2 className="h-6 w-6 animate-spin text-blue-500" />
              ) : (
                <MdUpdate className={`w-5 h-5`} />
              )}
            </button>
          ) : (
            <button
              onClick={() => {
                //@ts-ignore
                copyToClipboard(
                  `https://judexai-judge.vercel.app/chat/share/${share_id}`
                );
                setTimeout(() => {
                  dispatch(setSharedToken(share_id));
                }, 2000);
              }}
              className="p-2 rounded-lg bg-gray-700 hover:bg-gray-600"
            >
              <Copy className={`w-5 h-5 ${isCopied && "text-green-500"}`} />
            </button>
          )}
        </div>

        {/* Social Share Buttons */}
        {/* <div className="mt-4 flex items-center justify-center space-x-4">
          <a href="#" className="p-3 bg-gray-800 rounded-lg hover:bg-gray-700">
            🔗 LinkedIn
          </a>
          <a href="#" className="p-3 bg-gray-800 rounded-lg hover:bg-gray-700">
            📘 Facebook
          </a>
          <a href="#" className="p-3 bg-gray-800 rounded-lg hover:bg-gray-700">
            👽 Reddit
          </a>
          <a href="#" className="p-3 bg-gray-800 rounded-lg hover:bg-gray-700">
            ❌ X
          </a>
        </div> */}
      </div>
    </ModalV2>
  );
}

export default ShareModal;
